import { render, staticRenderFns } from "./CountersWithChangeSlot.vue?vue&type=template&id=6b6ff57c&scoped=true&"
import script from "./CountersWithChangeSlot.vue?vue&type=script&lang=js&"
export * from "./CountersWithChangeSlot.vue?vue&type=script&lang=js&"
import style0 from "./CountersWithChangeSlot.vue?vue&type=style&index=0&id=6b6ff57c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ff57c",
  null
  
)

export default component.exports